import { z } from 'zod';
import { TRUE_FALSE } from './helpers/enums.ts';

export const tunUseOffloadsSchema = z.enum([...TRUE_FALSE, '']);
export const tunUseOffloadsRequiredSchema = tunUseOffloadsSchema.refine((val) => val !== '', {
  message: 'Choose whether TUN offloads should be enabled',
});
